export default {
    attendaceEmployee: 'Attendance Employees',
    late: 'Late',
    absent: 'Absent',
    onsite: 'Onsite',
    leave: 'Leave',
    checkOut: 'Check-Out',
    earlyCheckOut: 'Early Check-Out',
    employeeNo: 'Employee No',
    fullName: 'Full-Name',
    timeCi: 'Check-In',
    timeCo: 'Check-Out',
    status: 'status'
}
